import axios from "axios";
import { BACKEND_URL } from "../../config/api";

export interface PromoCode {
  id: string;
  user_id: string;
  user_promo_code: string;
  pending_amount: number | null;
  transfered_amount: number | null;
  win_amount: number | null;
  amount_received_parrain: string | number;
  amount_received_filleule: string | number;
  currency: string;
  share_message: string | null;
  status: "ACTIVE" | "INACTIVE";
  created_at: string;
  updated_at: string;
}

export interface PromoCodeStat {
  user_id: string;
  promo_code: string;
  status?: "ACTIVE" | "INACTIVE";
  total_invited: number;
  pending: number;
  active: number;
  transferred?: number;
  earnings: number;
  pending_amount: number | null;
  transfered_amount: number | null;
  win_amount: number | null;
  filleule_amount?: number | null;
  currency: string;
  level: string;
  share_message: string;
  amount_received_parrain?: number;
  amount_received_filleule?: number;
  referrals: ReferralDetail[];
}

export interface ReferralDetail {
  id?: string;
  user_id: string;
  filleul_id?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  country_id?: number;
  is_verified?: string;
  status?: string;
  created_at?: string;
  has_transferred?: boolean;
  transfer_total?: number;
  transfer_currency?: string;
  transfer_count?: number;
  earnings?: number;
  earnings_currency?: string;
}

export interface UpdatePromoData {
  win_amount?: number;
  pending_amount?: number;
  transfered_amount?: number;
  currency?: string;
}

export const promoCodeService = {
  async createPromoCode(userId: string, token: string) {
    try {
      const response = await axios.post(
        `${BACKEND_URL}/promo-code/create`,
        { user_id: userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating promo code:", error);
      throw error;
    }
  },

  async updatePromoCode(userId: string, newCode: string, token: string) {
    try {
      const response = await axios.put(`${BACKEND_URL}/promo-code/${userId}?new_code=${newCode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (error) {
      console.error("Error updating promo code:", error);
      throw error;
    }
  },

  async getPromoCode(userId: string, token: string) {
    try {
      const response = await axios.get(`${BACKEND_URL}/promo-code/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data as PromoCode;
    } catch (error) {
      console.error("Error getting user promo code:", error);
      throw error;
    }
  },

  async getUserReferrals(userId: string, token: string) {
    try {
      const response = await axios.get(`${BACKEND_URL}/promo-code/${userId}/referrals`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (error) {
      console.error("Error getting user referrals:", error);
      throw error;
    }
  },

  async getUserPromoStats(userId: string, token: string) {
    try {
      const response = await axios.get(`${BACKEND_URL}/promo-code/${userId}/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data as PromoCodeStat;
    } catch (error) {
      console.error("Error getting user promo stats:", error);
      throw error;
    }
  },

  async updateUserRewards(
    userId: string,
    amount_received_parrain: number,
    amount_received_filleule: number,
    token: string
  ) {
    try {
      const response = await axios.put(
        `${BACKEND_URL}/promo-code/${userId}/rewards`,
        { amount_received_parrain, amount_received_filleule },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating reward per invite:", error);
      throw error;
    }
  },

  async updatePromoStatus(userId: string, status: "ACTIVE" | "INACTIVE", token: string) {
    try {
      const response = await axios.put(
        `${BACKEND_URL}/promo-code/${userId}/status`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.data as PromoCode;
    } catch (error) {
      console.error("Error updating promo status:", error);
      throw error;
    }
  },

  async updateShareMessage(userId: string, shareMessage: string, token: string) {
    try {
      const response = await axios.put(
        `${BACKEND_URL}/promo-code/${userId}/share-message`,
        { share_message: shareMessage },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating share message:", error);
      throw error;
    }
  },
};
